import React, { useEffect, useState } from "react";
import { HeightAnswerFormat } from "../../../../types/Survey";
import "./HeightQuestion.css"
import SurveyFormItem from "../../Components/SurveyFormItem/SurveyFormItem";
import "text-security/text-security.css"
import SurveyInput from "../../Components/SurveyInput/SurveyInput";
import { SurveyQuestionProps } from "../../Components/SurveyQuestion/SurveyQuestion";
import { QuestionResultModel } from "../../../../types/SurveyResult";

export default function (props: SurveyQuestionProps) {
    let answerFormat = props.answerFormat as HeightAnswerFormat;
    let currentResult = props.result as QuestionResultModel;

    let heightCm = parseFloat(currentResult.Answer || "0");

    let heightFeet = heightCm ? Math.floor(heightCm / 30.48).toFixed(0) : "";
    let heightInches = heightCm ? Math.round((heightCm % 30.48) / 2.54).toFixed(0) : "";

    let [feet, setFeet] = useState<string>(heightFeet);
    let [inches, setInches] = useState<string>(heightInches);

    function centimetersChanged(centimeters: string) {
        if (centimeters != "" && !matchesInputFormat(centimeters)) {
            return;
        }
        props.onResultChange({ ...props.result, Answer: centimeters } as QuestionResultModel);
    }

    function matchesInputFormat(value: string) {
        return /^[0-9]*\.?[0-9]*$/.test(value);
    }

    function feetChanged(newFeet: string) {
        if (newFeet != "" && !matchesInputFormat(newFeet)) {
            return;
        }

        setFeet(newFeet);

        let newHeightFeet = parseInt(newFeet);
        if (isNaN(newHeightFeet)) {
            newHeightFeet = 0;
        }
        let parseHeightInches = heightInches ? parseInt(heightInches) : 0;
        let newHeightCm = newHeightFeet * 30.48 + parseHeightInches * 2.54;
        props.onResultChange({ ...props.result, Answer: newHeightCm.toString() } as QuestionResultModel);
    }

    function inchesChanged(newInches: string) {
        if (newInches != "" && !matchesInputFormat(newInches)) {
            return;
        }
        setInches(newInches);

        let newHeightInches = parseInt(newInches);
        if (isNaN(newHeightInches)) {
            newHeightInches = 0;
        }
        let parseHeightFeet = heightFeet ? parseInt(heightFeet) : 0;
        let newHeightCm = parseHeightFeet * 30.48 + newHeightInches * 2.54;
        props.onResultChange({ ...props.result, Answer: newHeightCm.toString() } as QuestionResultModel);
    }

    return <SurveyFormItem
        className="height-question"
        topBorder
        bottomBorder
        label={props.label}
        labelFor={props.inputIdForLabel}
        labelPosition={props.labelPosition}
        variant={props.variant}
        useFieldsetFormat={props.useFieldsetFormat}
        index={props.index}>
        <div className="height-question-inputs">
            {answerFormat.measurementSystem == "USC" &&
                <>
                    <SurveyInput id={props.inputIdForLabel + "-ft"}
                        className="height-question-feet"
                        value={feet}
                        type="text"
                        placeholder="ft"
                        onChange={(e) => feetChanged(e.target.value)}
                        onEnterPressed={() => props.onEnterPressed()}
                        inputMode="decimal"
                        variant={props.variant}
                    />
                    <label htmlFor={props.inputIdForLabel + "-ft"} className="height-question-inline-label">ft</label>
                    <SurveyInput id={props.inputIdForLabel + "-in"}
                        className="height-question-inches"
                        value={inches}
                        type="text"
                        placeholder="in"
                        onChange={(e) => inchesChanged(e.target.value)}
                        onEnterPressed={() => props.onEnterPressed()}
                        inputMode="decimal"
                        variant={props.variant}
                    />
                    <label htmlFor={props.inputIdForLabel + "-in"} className="height-question-inline-label">in</label>
                </>
            }
            {answerFormat.measurementSystem == "Metric" &&
                <>
                    <SurveyInput id={props.inputIdForLabel + "-cm"}
                        className="height-question-centimeters"
                        value={currentResult.Answer}
                        type="text"
                        placeholder="cm"
                        onChange={(e) => centimetersChanged(e.target.value)}
                        onEnterPressed={() => props.onEnterPressed()}
                        inputMode="decimal"
                        variant={props.variant}
                    />
                    <label htmlFor={props.inputIdForLabel + "-cm"} className="height-question-inline-label">cm</label>
                </>
            }
        </div>
    </SurveyFormItem >
}